import { ITranslations } from 'types/common';
import { AdminUsersPopupTransFields } from './types';
import en from 'translations/en/adminUsersPopup.json';
import pl from 'translations/pl/adminUsersPopup.json';
import sl from 'translations/sl/adminUsersPopup.json';

export const adminUsersPopupTranslations: ITranslations<AdminUsersPopupTransFields> = {
  name: 'adminUsersPopup',
  en,
  pl,
  sl,
};
